import { ResetStoresContext } from "@/providers/reset-stores/ResetStoresContext";
import { useContext } from "react";

export const useResetStores = () => {
  const context = useContext(ResetStoresContext);
  if (context === undefined) {
    throw new Error("useResetStores must be used within a ResetStoresProvider");
  }
  return context;
};
